import { Gender } from "./Gender";
import { Serializable } from "../utilities/Serializable";
import { CurrentAccount } from "./CurrentAccount";

export class User extends Serializable{
  uuid: string;
  firstName: string;
  lastName: string;
  userName: string;
  telephoneNumber: string;
  email: string;
  dateOfBirth: string;

  password: string;

  address: string;
  city: string;
  province: string;
  cap: string;
  country: string;
  //enabled: boolean;
  
  gender: Gender;

  currentAccounts: CurrentAccount[];
  authorities: string[];
  role: string;
  notes: string;

  constructor() {
    super();

    this.gender = Gender.not_specified;
    this.currentAccounts = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/models/User.ts